import supabaseClient from "@/api/supabaseClient";
import { SupabaseClient } from "@supabase/supabase-js";
import { useMutation } from "@tanstack/react-query";
import { queryClient } from "@/main.tsx";
import type { Dna } from "$/models/Dna.d.ts";
import type { UpsertDnaRequest } from "$/requests/UpsertDnaRequest.ts";
import type { User } from '$/models/User';

const useUpsertDna = (refetch = true) => {
  const client = supabaseClient;

  const mutationFn = async (request: UpsertDnaRequest) => {
    return upsertDna(client, request);
  };

  return useMutation({
    mutationFn,
    onSuccess: async (updatedDna, request) => {
      if (!refetch) return;

      queryClient.setQueryData<User | null>(
        ["user", request.p_user_id],
        (currentUser) => {
          if (!currentUser) return currentUser;

          return {
            ...currentUser,
            dna: updatedDna,
          };
        },
      );

    },
  });
};

export default useUpsertDna;

async function upsertDna(
  client: SupabaseClient,
  request: UpsertDnaRequest,
): Promise<Dna> {
  const { data, error } = await client.rpc(
    "upsert_dna_data",
    request,
  );

  if (error) throw new Error(error.message);

  return data;
}
